import script from "./TempProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./TempProducts.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=588da700&scoped=true&lang=css"
import "./TempProducts.vue?vue&type=style&index=1&id=588da700&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-588da700"]])

export default __exports__